module.exports = __webpack_public_path__ + "media/configurations/P-X-SX-b489d38d.png";